import React from "react";

const Banner = () => {
  return (
    <>
      <a
        href="https://myanitureshop.com/shop"
        className="w-full  titlefont bg-[#F8F5FE]"
      >
        <img
          src="https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2F1_HeaderBanner%20(1).jpg?alt=media&token=256ae37e-ea80-4a1c-9362-693b81dc0841"
          className="w-full   lg:object-contain "
          alt=""
        />
      </a>
      <div className="grid md:grid-cols-3 grid-cols-1 gap-5 md:px-5 lg:px-10 px-2 my-14 ">
        <div className="flex flex-col items-center gap-3 ">
          <div className="w-full">
            <img
              className="max-h-52 w-full object-cover"
              src="https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2F2_HomeFurniture.WEBP?alt=media&token=097b0307-d375-4b60-9dad-e9da9d353585"
              alt=""
            />
          </div>
          <p className="titlefont text-lg">Home Furniture</p>
          <button className="px-4 titlefont rounded-full text-sm py-2 bg-[#d9cec2]">
            Shop Now
          </button>
        </div>
        <div className="flex flex-col items-center gap-3 ">
          <div className="w-full">
            <img
              className=" max-h-52 w-full object-cover"
              src="https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2F3_SchoolFurniture.JPG?alt=media&token=c616f8cc-82eb-4a7a-8ef4-ceae38a14eac"
              alt=""
            />
          </div>
          <p className="titlefont text-lg">School Furniture</p>
          <button className="px-4 titlefont rounded-full text-sm py-2 bg-[#d9cec2]">
            Shop Now
          </button>
        </div>
        <div className="flex flex-col items-center gap-3 ">
          <div className="w-full">
            <img
              className="max-h-52  w-full object-cover"
              src="https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2F4_OfficeFurniture.WEBP?alt=media&token=ef412358-5cb4-42f8-9da5-2beee1057c9c"
              alt=""
            />
          </div>
          <p className="titlefont text-lg">Office Furniture</p>
          <button className="px-4 titlefont rounded-full text-sm py-2 bg-[#d9cec2]">
            Shop Now
          </button>
        </div>
      </div>
      <div className="bg-[#E2D4C9]">
        <img
          className="md:block hidden w-full h-56 object-contain"
          src="https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2F5_SalePhoto.jpg?alt=media&token=00a9f19f-4fbf-4caa-897c-5c6ae7c86f33"
          alt=""
        />
        <img
          src="https://firebasestorage.googleapis.com/v0/b/piti-commerce.appspot.com/o/public%2F5_SalePhoto.jpg?alt=media&token=00a9f19f-4fbf-4caa-897c-5c6ae7c86f33"
          className="md:hidden"
          alt=""
        />
      </div>
    </>
  );
};

export default Banner;
